module.exports = __webpack_public_path__ + "static/media/asnb.8e69c8fa.png";